import React, { useState, useEffect } from 'react';
import firebase from 'firebase/app';

import OBdone from '../../onboarding/Modal/OBdone'
import OnboardVProp from '../../onboarding/Modal/OnboardVProp'
import Welcome from '../../onboarding/Modal/Welcome'
import Profile from '../Profile/Profile'
import AddVprop from '../Profile/subcomponents/Modal/AddVprop'
import RecentlySearched from '../RecentlySearched/RecentlySearched'
import SearchForProspect from '../SearchForProspect/SearchForProspect'
import SearchingSpinner from '../SearchingSpinner/SearchingSpinner'
import ContactsSlide from '../../../contactsPage/contactsSlide/ContactsSlide';

function MainDashboard({
    auth, 
    fbProfile, 
    FBvalueProp, 
    tokens, 
    interestValues,
    callToAction,
    firstCopy,
    searchedContactLastFive,
    onboarded,
    profile,
    setProfile,
    allUserContacts,
    searchedContacts,
    teamToken
}) {

    const [ showSearching, setShowSearching ] = useState(false)
    const [ foundInts, setFoundInts ] = useState('')
    const [ interests, setInterests ] = useState('')
    const [ docId, setDocId ] = useState('')
    const [ contentGen, setContentGen] = useState('')
    const [ error, setError ] = useState('')
    const [ intVal, setIntVal ] = useState('')
    const [ vProp, setVprop ] = useState ('')
    const [ shownButton, setShownButton ] = useState('Short Intro')
    const [ generating, setGenerating ] = useState(false)
    const [ url, setURL ] = useState('')
    const [ clickedYesorNo, setClickedYesorNo ] = useState(false)
    // const [ showTooltip, setShowTooltip ] = useState(false);
    const [ editing, setEditing ] = useState(false)
    const [ showBtn, setShowBtn ] = useState(true);
    const [ showCustom, setShowCustom ] = useState(false)
    const [ showWelcome, setShowWelcome ] = useState(false)
    const [ showOBvprop, setShowOBvprop ] = useState(false)
    const [ showOBdone, setShowOBdone ] = useState(false)
    const [ showProfileVpropAdd, setShowProfileVpropAdd ] = useState(false)
    const [ intLoad, setIntLoad ] = useState(false)
    const [ email, setEmail ] = useState('')
    const [ emailFinderGen, setEmailFinderGen ] = useState(false)
    const setShowTooltip = false
    const [ oneLinerModel, setOneLinerModel ] = useState(false)
    const [ actionInitModel, setActionInitModel ] = useState(false)
    const [ probingModel, setProbingModel ] = useState(false)


    const [openSlide, setOpenSlide] = useState(false)
    const [ tokensTeam, setTokensTeam ] = useState()

    // const [ valueIndex, setValueIndex ] = useState('default')

    const valueIndex = localStorage.getItem('valueIndex') !== null ? localStorage.getItem('valueIndex') : 'default'
    // console.log(valueIndex)
    // console.log(vProp)

    // console.log(profile)

    const selectedVprop = (e) =>{
        // console.log(e)
        setVprop(FBvalueProp[e])
        // setValueIndex(e.currentTarget.value)
        localStorage.setItem('valueIndex', e)
    }

    const backButton = () =>{
        setProfile('')
        setEditing(false)
    }

    useEffect(() =>{
        var isMounted = true;
        var db = firebase.firestore();

        const checkVprop = () =>{
            if(FBvalueProp.length === 1){
                setVprop(FBvalueProp[0])
                localStorage.setItem('valueIndex', 0)
            }
            else if(valueIndex !== null){
                setVprop(FBvalueProp[valueIndex])
            }
        }

        const showTooltipAndBtn = () =>{ 
            if((intVal !== '') && (vProp !== '') && (vProp !== undefined)){
                // setShowTooltip(true)
                setShowBtn(false)
            }else{
                // setShowTooltip(false)
                setShowBtn(true)
            }
        }

        const pauseGenerate = () =>{
            if(generating === true){
                // setShowTooltip(false)
                setShowBtn(true)
            }
        }

        const zeroTokens = () =>{
            if(tokens?.totalTokens < 1){
                setShowBtn(true)
            }
        }

        const showWelcome = () =>{
            if(onboarded?.[0]?.welcomeClicked === 'no'){
                setShowWelcome(true)
            } else {
                setShowWelcome(false)
            }
        }

        //get num of teamTokens

        async function fetchData() {
            await db.collection('customers')
                      .doc(teamToken?.[0]?.adminId)
                      .collection('tokens')
                      .doc(teamToken?.[0]?.adminId)
                      .get().then((doc) => {
                        if (doc.exists) {
                            //console.log("Document data:", doc.data());
                            setTokensTeam(doc.data().totalTokens)
                        } else {
                            // doc.data() will be undefined in this case
                            //console.log("No such document!");
                            setTokensTeam(0) 
                        }
                    }).catch((error) => {
                        console.log("Error getting document:", error);
                    });
            }
    
          if(teamToken?.[0]?.adminId !== undefined && teamToken?.[0]?.teamToken === true && isMounted === true){
            fetchData();
          }else{
            setTokensTeam(0) 
          }
    

        checkVprop()
        showTooltipAndBtn()
        pauseGenerate()
        zeroTokens()
        showWelcome()

        return () => {
            isMounted = false;
          };

    }, [valueIndex, setVprop, FBvalueProp, setShowBtn, tokens, intVal, vProp, generating, onboarded, setShowWelcome, teamToken])

    return (
        <div>
            <ContactsSlide 
            //contacts={allUserContacts}
            setProfile={setProfile}
            open={openSlide} 
            setOpen={setOpenSlide}
            contacts={searchedContacts}
            setLIurl={setURL}
            setInterests={setInterests}
            setContentGen={setContentGen}
            setFoundInts={setFoundInts}
            setDocId={setDocId}
            />
            {/* Show Pre Search */}
            {/* Searching For Prospect With Linkedin */}
            {/* If not showing spinner and profile is blank and no error shown then show search for prospect & recently searched */}
            {/* All Onboarding */}
            { showWelcome ? 
            <Welcome 
            showWelcome={showWelcome}
            setShowWelcome={setShowWelcome}
            auth={auth}
            setShowOBvprop={setShowOBvprop}
            />
            :
            null
            }
            {showOBvprop ?
            <OnboardVProp 
            setShowOBvprop={setShowOBvprop}
            showOBvprop={showOBvprop}
            profile={fbProfile}
            auth={auth}
            FBvalueProp={FBvalueProp}
            setShowOBdone={setShowOBdone}
            />
            :
            null
            }
            <OBdone 
            setShowOBdone={setShowOBdone}
            showOBdone={showOBdone}
            auth={auth}
            />
            <AddVprop 
            setShowProfileVpropAdd={setShowProfileVpropAdd}
            showProfileVpropAdd={showProfileVpropAdd}
            profile={fbProfile}
            auth={auth}
            FBvalueProp={FBvalueProp}
            />
            {error !== '' ?
            <div>
                <SearchForProspect 
                setShowSearching={setShowSearching}
                setProfile={setProfile}
                auth={auth}
                fbProfile={fbProfile}
                setFoundInts={setFoundInts}
                setInterests={setInterests}
                setDocId={setDocId}
                setContentGen={setContentGen}
                setError={setError}
                url={url}
                setURL={setURL}
                setEmail={setEmail}
                setOpenSlide={setOpenSlide}
                openSlide={openSlide}
                />
                <div className="mt-2 bg-white rounded shadow p-4 text-left text-lg">
                    <span>
                    Oops, we couldn't find this prospect. You can try again or you can click here to manually create a message.
                    </span>
                    <br />
                    <button 
                        className="mt-3 p-1 bg-blue-800 border-2 border-blue-600 rounded text-white px-4 font-semibold hover:bg-blue-700"
                        onClick={() => setError('')}
                    >
                        Create Message
                    </button>
                </div>
            </div>
            :
            (showSearching ? 
            <SearchingSpinner />
            :
            (profile !== '' ? 
                <div>
                    <Profile 
                    profile={profile}
                    interests={interests}
                    contentGen={contentGen}
                    setIntVal={setIntVal}
                    intVal={intVal}
                    FBvalueProp={FBvalueProp}
                    selectedVprop={selectedVprop}
                    valueIndex={valueIndex}
                    setShownButton={setShownButton}
                    shownButton={shownButton}
                    fbProfile={fbProfile}
                    vProp={vProp}
                    auth={auth}
                    setContentGen={setContentGen}
                    setGenerating={setGenerating}
                    tokens={tokens}
                    docId={docId}
                    url={url}
                    foundInts={foundInts}
                    interestValues={interestValues}
                    callToAction={callToAction}
                    setBtnClicked={setClickedYesorNo}
                    setShowTooltip={setShowTooltip}
                    generating={generating}
                    firstCopy={firstCopy}
                    fireClicked={clickedYesorNo}
                    editing={editing} 
                    setEditing={setEditing}
                    showBtn={showBtn}
                    setURL={setURL}
                    setError={setError}
                    setDocId={setDocId}
                    setInterests={setInterests}
                    setFoundInts={setFoundInts}
                    setShowSearching={setShowSearching}
                    setProfile={setProfile}
                    backButton={backButton}
                    setShowProfileVpropAdd={setShowProfileVpropAdd}
                    onboarded={onboarded}
                    intLoad={intLoad} 
                    setIntLoad={setIntLoad}
                    setEmailFinderGen={setEmailFinderGen}
                    emailFinderGen={emailFinderGen}
                    email={email}
                    setEmail={setEmail}
                    teamToken={teamToken}
                    tokensTeam={tokensTeam}
                    oneLinerModel={oneLinerModel}
                    setOneLinerModel={setOneLinerModel}
                    actionInitModel={actionInitModel}
                    setActionInitModel={setActionInitModel}
                    probingModel={probingModel}
                    setProbingModel={setProbingModel}
                    />
                </div>
                :
                <div>
                    <SearchForProspect 
                    setShowSearching={setShowSearching}
                    setProfile={setProfile}
                    auth={auth}
                    fbProfile={fbProfile}
                    setFoundInts={setFoundInts}
                    setInterests={setInterests}
                    setDocId={setDocId}
                    setContentGen={setContentGen}
                    setError={setError}
                    url={url}
                    setURL={setURL}
                    setEmail={setEmail}
                    setOpenSlide={setOpenSlide}
                    openSlide={openSlide}
                    />
                    <RecentlySearched 
                    searchedContactLastFive={searchedContactLastFive}
                    setShowCustom={setShowCustom}
                    showCustom={showCustom}
                    FBvalueProp={FBvalueProp}
                    auth={auth}
                    fbProfile={fbProfile}
                    tokens={tokens}
                    interestValues={interestValues}
                    callToAction={callToAction}
                    firstCopy={firstCopy}
                    setProfile={setProfile}
                    setLIurl={setURL}
                    setInterests={setInterests}
                    setContentGen={setContentGen}
                    setFoundInts={setFoundInts}
                    setDocId={setDocId}
                    teamToken={teamToken}
                    tokensTeam={tokensTeam}
                    />
                </div>
            )
            )
            }

            {/* If spinner is showing generating, then show that */}
            {/* If spinner is false, but profile is shown as full then show profile */}
            {/* If spinner is false, but error is shown, then show error */}
        </div>
    )
}

export default MainDashboard
